var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 2.25H7.51562V1.23438C7.51562 0.904297 7.76953 0.625 8.125 0.625C8.45508 0.625 8.73438 0.904297 8.73438 1.23438V2.25H9.75C10.6387 2.25 11.375 2.98633 11.375 3.875V12C11.375 12.9141 10.6387 13.625 9.75 13.625H1.625C0.710938 13.625 0 12.9141 0 12V3.875C0 2.98633 0.710938 2.25 1.625 2.25H2.64062V1.23438C2.64062 0.904297 2.89453 0.625 3.25 0.625C3.58008 0.625 3.85938 0.904297 3.85938 1.23438V2.25ZM1.21875 12C1.21875 12.2285 1.39648 12.4062 1.625 12.4062H9.75C9.95312 12.4062 10.1562 12.2285 10.1562 12V5.5H1.21875V12Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.4abf45e93bc65a74ddba7f6eb50c9c2d.svg";
export { ForwardRef as ReactComponent };